import { getToken, logout, getPlatConfig } from './index';
import { Toast } from 'antd-mobile';

function getDefaultHeaders() {
  const _headerObj = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  const token = getToken();
  if (token) {
    _headerObj['accessToken'] = token;
  }
  return new Headers(_headerObj);
}

function getPlatformUrl() {
  const { platformUrl } = getPlatConfig() || { platformUrl: '' };
  return platformUrl;
}

let _getParamFormat = function (params) {
  let paramStr = '';
  if (params) {
    for (let key in params) {
      paramStr += key + '=' + params[key] + '&';
    }
    if (paramStr.length > 0) {
      paramStr = paramStr.substring(0, paramStr.length - 1);
    }
  }
  return paramStr;
};
let _fetch = function (request) {
  return fetch(request)
    .then(function (response) {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.statusText));
      }
    })
    .then(function (response) {
      let contentType = response.headers.get('content-type');
      if (!contentType) {
        return response.text();
      }
      if (contentType && contentType.includes('text/plain')) {
        return response.text();
      } else {
        const respJson = response.json();
        respJson.then((result) => {
          if (result && result.retCode && result.retCode === '200014') {
            logout();
          }
        });
        return respJson;
      }
    })
    .catch((err) => {
      Toast.info(err);
    });
};
export function get(url, params, options) {
  const prevUrl = getPlatformUrl() || '';
  url = prevUrl + url;
  if (params) {
    url = url + '?' + _getParamFormat(params);
  }
  let _options = {
    credentials: 'include',
    method: 'GET',
    headers: (options && options.headers) || getDefaultHeaders(),
    cache: (options && options.cache) || 'default',
  };
  let request = new Request(url, _options);
  return _fetch(request);
}

export function post(url, params, options) {
  const prevUrl = getPlatformUrl() || '';
  url = prevUrl + url;
  let urlParam = _getParamFormat(params);
  let _options = {
    credentials: 'include',
    method: 'POST',
    headers: (options && options.headers) || getDefaultHeaders(),
    cache: (options && options.cache) || 'default',
    mode: 'cors',
    body: urlParam,
  };
  let request = new Request(url, _options);
  return _fetch(request);
}

export function put(url, params, options) {
  const prevUrl = getPlatformUrl() || '';
  url = prevUrl + url;
  let urlParam = _getParamFormat(params);
  let _options = {
    credentials: 'include',
    method: 'PUT',
    headers: (options && options.headers) || getDefaultHeaders(),
    cache: (options && options.cache) || 'default',
    mode: 'cors',
    body: urlParam,
  };
  let request = new Request(url, _options);
  return _fetch(request);
}

export function del(url, params, options) {
  const prevUrl = getPlatformUrl() || '';
  url = prevUrl + url;
  let urlParam = _getParamFormat(params);
  let _options = {
    credentials: 'include',
    method: 'DELETE',
    headers: (options && options.headers) || getDefaultHeaders(),
    cache: (options && options.cache) || 'default',
    mode: 'cors',
    body: urlParam,
  };
  let request = new Request(url, _options);
  return _fetch(request);
}
